/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverInviteDtoModel, DriverInviteDtoModelType } from "./DriverInviteDtoModel"
import { DriverInviteDtoModelSelector } from "./DriverInviteDtoModel.base"
import { OrganizationDtoModel, OrganizationDtoModelType } from "./OrganizationDtoModel"
import { OrganizationDtoModelSelector } from "./OrganizationDtoModel.base"
import { UserDtoModel, UserDtoModelType } from "./UserDtoModel"
import { UserDtoModelSelector } from "./UserDtoModel.base"
import { UserInviteDtoModel, UserInviteDtoModelType } from "./UserInviteDtoModel"
import { UserInviteDtoModelSelector } from "./UserInviteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  user: UserDtoModelType;
  invite: DriverInviteDtoModelType;
  organization: OrganizationDtoModelType;
  userInvite: UserInviteDtoModelType;
}

/**
 * DriverDtoBase
 * auto generated base class for the model DriverDtoModel.
 */
export const DriverDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('DriverDto')
  .props({
    __typename: types.optional(types.literal("DriverDto"), "DriverDto"),
    id: types.identifier,
    organizationId: types.union(types.undefined, types.integer),
    name: types.union(types.undefined, types.string),
    speed: types.union(types.undefined, types.null, types.number),
    capacity: types.union(types.undefined, types.null, types.number),
    breakStartTime: types.union(types.undefined, types.null, types.string),
    breakEndTime: types.union(types.undefined, types.null, types.string),
    active: types.union(types.undefined, types.null, types.boolean),
    createdOn: types.union(types.undefined, types.string),
    uuid: types.union(types.undefined, types.string),
    user: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserDtoModel))),
    invite: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => DriverInviteDtoModel))),
    organization: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => OrganizationDtoModel))),
    userInvite: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserInviteDtoModel))),
    deleted: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class DriverDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get name() { return this.__attr(`name`) }
  get speed() { return this.__attr(`speed`) }
  get capacity() { return this.__attr(`capacity`) }
  get breakStartTime() { return this.__attr(`breakStartTime`) }
  get breakEndTime() { return this.__attr(`breakEndTime`) }
  get active() { return this.__attr(`active`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get uuid() { return this.__attr(`uuid`) }
  get deleted() { return this.__attr(`deleted`) }
  user(builder: string | UserDtoModelSelector | ((selector: UserDtoModelSelector) => UserDtoModelSelector) | undefined) { return this.__child(`user`, UserDtoModelSelector, builder) }
  invite(builder: string | DriverInviteDtoModelSelector | ((selector: DriverInviteDtoModelSelector) => DriverInviteDtoModelSelector) | undefined) { return this.__child(`invite`, DriverInviteDtoModelSelector, builder) }
  organization(builder: string | OrganizationDtoModelSelector | ((selector: OrganizationDtoModelSelector) => OrganizationDtoModelSelector) | undefined) { return this.__child(`organization`, OrganizationDtoModelSelector, builder) }
  userInvite(builder: string | UserInviteDtoModelSelector | ((selector: UserInviteDtoModelSelector) => UserInviteDtoModelSelector) | undefined) { return this.__child(`userInvite`, UserInviteDtoModelSelector, builder) }
}
export function selectFromDriverDto() {
  return new DriverDtoModelSelector()
}

export const driverDtoModelPrimitives = selectFromDriverDto().organizationId.name.speed.capacity.breakStartTime.breakEndTime.active.createdOn.uuid.deleted
